import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/commercial-credit-application-listing/:guid?",
    name: "Commercial Credit Applications",
    component: () => import("./commercialCreditApplications.vue"),
  },
  {
    path: "/credit-enrollment-review",
    name: "Credit Review",
    component: () => import("./creditEnrollmentReview.vue"),
  },
] satisfies RouteRecordRaw[];
